import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from './components/Login.vue'
import ExamList from './components/ExamList.vue'
import ExamPlan from './components/ExamPlan.vue'
import ExamDetail from './components/ExamDetail.vue'
import ExamPendency from './components/ExamPendency.vue'
import ExamChairList from './components/ExamChairList.vue'
import ExamEvaluateList from './components/ExamEvaluateList.vue'
import ExamEvaluateDetail from './components/ExamEvaluateDetail.vue'
import ExamImport from './components/ExamImport.vue'
import ExamSchedule from './components/ExamSchedule.vue'
import RegisterExternalExaminer from './components/RegisterExternalExaminer.vue'
import RegisterExternalListener from './components/RegisterExternalListener.vue'
import ExamTerms from './components/ExamTerms.vue'
import CourseConfigs from './components/CourseConfigs.vue'

import auth from './auth'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: ExamSchedule, props: true, meta: { auth: false } },
  { path: '/bancas', component: ExamList, meta: { auth: true } },
  { path: '/bancas/pendencias', component: ExamPendency, meta: { auth: true } },
  { path: '/bancas/termos', component: ExamTerms, meta: { auth: true } },
  { path: '/bancas/planejar', component: ExamPlan, meta: { auth: true }, props: { id: 0 } },
  { path: '/bancas/planejar/:id', component: ExamPlan, name: 'examPlan', props: true, meta: { auth: true } },
  { path: '/bancas/registrar', component: ExamDetail, name: 'examRecord', meta: { auth: true }, props: { id: 0 } },
  { path: '/bancas/presidir', component: ExamChairList, meta: { auth: true } },
  { path: '/bancas/avaliar', component: ExamEvaluateList, meta: { auth: true } },
  { path: '/bancas/avaliar/:id', component: ExamEvaluateDetail, name: 'examEvaluate', props: true, meta: { auth: true } },
  { path: '/bancas/avaliar/:id/:evaluator', component: ExamEvaluateDetail, name: 'examEvaluationDetail', props: true, meta: { auth: true } },
  { path: '/bancas/importar', component: ExamImport, name: 'examImport', meta: { auth: true } },
  { path: '/bancas/:id', component: ExamDetail, name: 'examDetail', props: true, meta: { auth: true } },
  { path: '/cronograma/:courseSlug', component: ExamSchedule, name: 'courseExamSchedule', props: true, meta: { auth: false } },
  { path: '/cronograma', component: ExamSchedule, name: 'examSchedule', props: true, meta: { auth: false } },
  { path: '/ouvinte/cadastrar', component: RegisterExternalListener, name: 'registerExternalListener', props: true, meta: { auth: false } },
  { path: '/avaliador/cadastrar', component: RegisterExternalExaminer, meta: { auth: true } },
  { path: '/ata/:chave', beforeEnter: to => {
    location.href = process.env.MINUTES_URL + to.params.chave
  } },
  { path: '/curso/configuracoes', component: CourseConfigs, name: 'courseConfigs', props: true, meta: { auth: true } },
  { path: '/entrar/:userTypeDef', component: Login, props: true },
  { path: '/entrar', component: Login },
  { path: '*', component: ExamSchedule }
]

const basePath = '/'

const router = new VueRouter({
  mode: 'history',
  base: basePath,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !auth.user.authenticated) {
    next('/entrar')
  } else {
    if (to.path == '/entrar' && auth.user.authenticated) {
      next('/')
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js